import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import pl from '../content/pl.json'
import en from '../content/en.json'

const resources = {
  pl: { translation: pl },
  en: { translation: en }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pl', // Default to Polish since it's a Polish market app
    lng: 'pl', // Start with Polish

    detection: {
      order: ['queryString', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },

    interpolation: {
      escapeValue: false,
    },

    returnObjects: true, // Allow returning objects for complex data structures
  })

export default i18n